import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { ProductKeys } from '@/types/ProductEnums';
import { DOT_SYMBOL } from '~/constants';
import { capitalizeFirstLetter } from '~/utils';
import { isProductInStock, isProductDiscontinued } from '~/utils/ProductAvailability';
export default (function () {
  var _useNuxt2App = useNuxt2App(),
    locale = _useNuxt2App.i18n.locale;
  var sortAlphabetically = function sortAlphabetically(a, b) {
    var _a$attributes$color, _b$attributes$color;
    var aColor = (_a$attributes$color = a.attributes.color) === null || _a$attributes$color === void 0 ? void 0 : _a$attributes$color.label;
    var bColor = (_b$attributes$color = b.attributes.color) === null || _b$attributes$color === void 0 ? void 0 : _b$attributes$color.label;
    if (aColor > bColor) return 1;
    if (aColor < bColor) return -1;
    return 0;
  };
  var getVariantAttribute = function getVariantAttribute(attributes, variant, attribute) {
    var _variant$value, _variant$value$attrib, _variant$value2;
    var isLocalized = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var skipCurrent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    if (isLocalized) return (attributes === null || attributes === void 0 ? void 0 : attributes.value) || ((_variant$value = variant.value) === null || _variant$value === void 0 ? void 0 : (_variant$value$attrib = _variant$value[attribute]) === null || _variant$value$attrib === void 0 ? void 0 : _variant$value$attrib.value) || undefined;
    return (attributes === null || attributes === void 0 ? void 0 : attributes[attribute]) || (skipCurrent ? undefined : (_variant$value2 = variant.value) === null || _variant$value2 === void 0 ? void 0 : _variant$value2[attribute]) || undefined;
  };
  var checkAttribute = function checkAttribute(existingOptions, currentOption, attribute) {
    var _existingOptions$attr;
    var isLocalized = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // ".value? breaks?"
    if (isLocalized) return (existingOptions === null || existingOptions === void 0 ? void 0 : (_existingOptions$attr = existingOptions[attribute]) === null || _existingOptions$attr === void 0 ? void 0 : _existingOptions$attr.value) === (currentOption === null || currentOption === void 0 ? void 0 : currentOption[attribute]);
    return (existingOptions === null || existingOptions === void 0 ? void 0 : existingOptions[attribute]) === (currentOption === null || currentOption === void 0 ? void 0 : currentOption[attribute]);
  };
  var findRawAttribute = function findRawAttribute(variant, attributeName) {
    var _variant$attributesRa;
    return (_variant$attributesRa = variant.attributesRaw.find(function (attribute) {
      return attribute.name === attributeName;
    })) === null || _variant$attributesRa === void 0 ? void 0 : _variant$attributesRa.value;
  };
  var normalizeVariants = function normalizeVariants(variants) {
    return variants.map(function (variant) {
      var _capacityUnit$label, _capacityType$label, _variant$images, _variant$images$;
      if (!(variant !== null && variant !== void 0 && variant.sku)) return null;
      var capacity = findRawAttribute(variant, ProductKeys.capacity);
      var capacityUnit = findRawAttribute(variant, ProductKeys.capacityUnit);
      var capacityType = findRawAttribute(variant, ProductKeys.capacityType);
      var color = findRawAttribute(variant, ProductKeys.color);
      var capacityAndUnitLabel = capacity ? capacity + ((capacityUnit === null || capacityUnit === void 0 ? void 0 : (_capacityUnit$label = capacityUnit.label) === null || _capacityUnit$label === void 0 ? void 0 : _capacityUnit$label[locale]) || '') : '';
      var capacityTypeLabel = (capacityType === null || capacityType === void 0 ? void 0 : (_capacityType$label = capacityType.label) === null || _capacityType$label === void 0 ? void 0 : _capacityType$label[locale]) || '';
      var separator = capacityTypeLabel ? " ".concat(DOT_SYMBOL, " ") : '';
      var isSellable = findRawAttribute(variant, ProductKeys.isSellable);
      var isComplimentary = findRawAttribute(variant, ProductKeys.isComplimentary);
      var entry = {
        id: variant.id,
        sku: variant.sku,
        price: variant.price,
        isSellable: (isSellable === null || isSellable === void 0 ? void 0 : isSellable.key) === ProductKeys.inStock,
        isDiscontinued: isSellable.key === ProductKeys.discontinued,
        isComplimentary: isComplimentary,
        mainImage: variant === null || variant === void 0 ? void 0 : (_variant$images = variant.images) === null || _variant$images === void 0 ? void 0 : (_variant$images$ = _variant$images[0]) === null || _variant$images$ === void 0 ? void 0 : _variant$images$.url,
        images: variant === null || variant === void 0 ? void 0 : variant.images,
        isMaster: variant._master,
        name: variant._name,
        attributesRaw: variant.attributesRaw,
        attributes: {
          capacity: _defineProperty(_defineProperty(_defineProperty({
            capacity: capacity,
            value: capacity
          }, ProductKeys.capacityType, capacityType === null || capacityType === void 0 ? void 0 : capacityType.key), ProductKeys.capacityUnit, capacityUnit === null || capacityUnit === void 0 ? void 0 : capacityUnit.key), "label", capacityAndUnitLabel + separator + capitalizeFirstLetter(capacityTypeLabel)),
          color: {
            label: color === null || color === void 0 ? void 0 : color.label[locale],
            value: color === null || color === void 0 ? void 0 : color.key,
            color: color === null || color === void 0 ? void 0 : color.key
          }
        }
      };
      return entry;
    }).filter(function (v) {
      return !!v;
    });
  };
  var findFirstSellable = function findFirstSellable(variants) {
    var _variants$find, _variants$filter;
    var masterVariant = (_variants$find = variants.find(function (variant) {
      return variant.isMaster === true;
    })) !== null && _variants$find !== void 0 ? _variants$find : {};
    var inStockVariants = (_variants$filter = variants.filter(function (variant) {
      return isProductInStock(variant);
    })) !== null && _variants$filter !== void 0 ? _variants$filter : [];
    if (masterVariant && isProductInStock(masterVariant) && !isProductDiscontinued(masterVariant) || !inStockVariants.length) {
      return masterVariant;
    } else {
      return inStockVariants[0];
    }
  };

  // todo find better way
  var checkNormalizedAttribute = function checkNormalizedAttribute(variant, attributes, key) {
    var _variant$attributes$k, _attributes$key;
    return ((_variant$attributes$k = variant.attributes[key]) === null || _variant$attributes$k === void 0 ? void 0 : _variant$attributes$k.label) === ((_attributes$key = attributes[key]) === null || _attributes$key === void 0 ? void 0 : _attributes$key.label);
  };
  var findVariantByAttrib = function findVariantByAttrib(variants, attributes) {
    var matchedVariant = variants.find(function (variant) {
      return checkNormalizedAttribute(variant, attributes, ProductKeys.capacity) && checkNormalizedAttribute(variant, attributes, ProductKeys.color);
    });
    if (!matchedVariant || !matchedVariant.isSellable) {
      var sellableVariants = variants.filter(function (v) {
        return checkNormalizedAttribute(v, attributes, ProductKeys.capacity);
      });
      var bestMatch = sellableVariants.filter(function (v) {
        return checkNormalizedAttribute(v, attributes, ProductKeys.color);
      });
      var sortedSellableVariants = sellableVariants.sort(sortAlphabetically);
      matchedVariant = bestMatch.length > 0 ? bestMatch[0] : sortedSellableVariants[0];
    }
    return matchedVariant;
  };
  return {
    getVariantAttribute: getVariantAttribute,
    checkAttribute: checkAttribute,
    findRawAttribute: findRawAttribute,
    sortAlphabetically: sortAlphabetically,
    normalizeVariants: normalizeVariants,
    findFirstSellable: findFirstSellable,
    findVariantByAttrib: findVariantByAttrib
  };
});